
import { Component, Prop, Vue } from 'vue-property-decorator'

import { UrsafEvent } from '@/models'
import { DotationNature, DotationOrderForm } from '../types/dotationOrderForm'

@Component({ name: 'StepDotationNature' })
export default class extends Vue {
  @Prop({ required: true }) form!: DotationOrderForm

  events: UrsafEvent[] = []
  loading = false

  created(): void {
    this.loadEvents()
  }

  async loadEvents(): Promise<void> {
    this.loading = true
    try {
      const { data } = await UrsafEvent.page(1).per(999).all()
      this.events = data
      if (this.form.ursafEventId) {
        const selected = this.events.find(event => event.id === this.form.ursafEventId)
        this.form.ursafEventName = selected?.name || ''
      }
    } catch (error) {
      this.$notify({
        title: String(this.$t('newDotationOrder.notification.errorTitle')),
        message: String(this.$t('newDotationOrder.event.loadError')),
        type: 'error',
        duration: 5000
      })
    } finally {
      this.loading = false
    }
  }

  selectNature(nature: DotationNature): void {
    this.form.nature = nature
    if (nature !== 'urssaf') {
      this.form.ursafEventId = ''
      this.form.ursafEventName = ''
    }
  }

  onEventChange(eventId: string): void {
    const selected = this.events.find(event => event.id === eventId)
    this.form.ursafEventName = selected?.name || ''
  }
}
